import Text from "@/shared/typography/text";
import { PersonCommentLabelFragment } from "gql/graphql";
import { hasName } from "@/shared/data-display/localized-value";
import { Position } from "../../company-structure/position";
import { PersonAvatar } from "../person-avatar";
import { useAgoFormatter } from "@/shared/formatters";
import { PersonNameLink } from "../person-name-link";
import { Hidable, Value } from "@/shared/value";

export function PersonCommentLabel({
  data,
  date,
}: {
  data?: Hidable<PersonCommentLabelFragment>;
  date: string;
}) {
  const ago = useAgoFormatter(date);

  return (
    <Value data={data}>
      {(person) => (
        <div className="flex items-center space-x-2">
          <div>
            <PersonAvatar data={person} />
          </div>

          <div>
            <Text type="body1">
              <PersonNameLink data={person} />
            </Text>
            <Text color="secondary" type="caption">
              {hasName(person.position) && (
                <span className="hidden xl:inline">
                  <Position.Name data={person.position} /> •{" "}
                </span>
              )}
              <span>{ago}</span>
            </Text>
          </div>
        </div>
      )}
    </Value>
  );
}
